/* Hallmark · F4 Step sequence knobs: numbering=01/02/03, layout=vertical stack, connector=line
 * Three steps because that is how many the flow actually has — copy, pick, redeem.
 */
import { type VoucherScope } from '@/types/voucher';

interface VoucherStepsProps {
  code: string;
  scope: VoucherScope;
  /** False for fixed-amount codes, which the cart cannot process. */
  redeemable: boolean;
}

export function VoucherSteps({ code, scope, redeemable }: VoucherStepsProps) {
  // A code that cannot be applied online has a different last step, and pretending
  // otherwise would send people to a checkout that rejects it.
  const steps = redeemable
    ? [
        { title: 'Chép mã', body: `Nhấn "Chép mã" để lưu ${code} vào bộ nhớ tạm.` },
        {
          title: 'Chọn dịch vụ',
          body:
            scope === 'global'
              ? 'Chọn điểm đến và gói dịch vụ bạn muốn đặt, rồi thêm vào giỏ hàng.'
              : 'Chọn gói dịch vụ áp dụng được ở phần trên, rồi thêm vào giỏ hàng.',
        },
        { title: 'Nhập mã ở giỏ hàng', body: 'Dán mã vào ô "Mã giảm giá" trong giỏ hàng để trừ trực tiếp vào đơn.' },
      ]
    : [
        { title: 'Chép mã', body: `Nhấn "Chép mã" để lưu ${code} vào bộ nhớ tạm.` },
        { title: 'Đến quầy', body: 'Mang mã tới quầy vé tại điểm đến áp dụng.' },
        { title: 'Xuất trình mã', body: 'Nhân viên sẽ áp dụng ưu đãi trực tiếp khi thanh toán.' },
      ];

  return (
    <ol className="relative space-y-6">
      {steps.map((step, index) => (
        <li key={step.title} className="relative flex gap-4 pl-1">
          {/* The connector stops before the last marker so the sequence reads as ended. */}
          {index < steps.length - 1 && (
            <span className="absolute top-9 bottom-[-1.5rem] left-[1.125rem] w-px bg-(--pill-border)" aria-hidden="true" />
          )}
          <span
            className="bg-(--brand-orange-soft) text-primary-ink relative flex size-9 shrink-0 items-center justify-center rounded-full font-mono text-sm font-bold tabular-nums"
            aria-hidden="true"
          >
            {String(index + 1).padStart(2, '0')}
          </span>
          <div className="min-w-0 pt-1">
            <p className="font-semibold text-gray-900">{step.title}</p>
            <p className="text-muted-foreground-strong mt-1 text-sm">{step.body}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
